import baseDataLayer from './baseDataLayer';

const benefitsPageBtnEvent = (): void =>
  baseDataLayer({
    event_params: {
      page: '/csi/landing',
      page_title: 'CSI - Landing',
      product: 'CSI',
      action_type: 'click',
      action: 'Click botón “Conoce todos los beneficios',
      view_type: 'web',
      product_type: '',
      asegurados: '',
      enfermedad: '',
      prima: '',
      venta_asistida: '',
      rut_agente: '',
    },
    user: { userId: '' },
    userEmail: '',
  });

const benefitsLandingViewPageEvent = (): void =>
  baseDataLayer({
    event: 'vpv',
    event_params: {
      page: '/csi/beneficios',
      page_title: 'CSI - Beneficios',
      product: 'CSI',
      action_type: 'Pageview',
      action: 'Pantalla beneficios',
      view_type: 'web',
      product_type: '',
      asegurados: '',
      enfermedad: '',
      prima: '',
      venta_asistida: '',
      rut_agente: '',
    },
    user: { userId: '' },
    userEmail: '',
  });

const showPlansInBenefitsBtnEvent = (): void =>
  baseDataLayer({
    event: 'vpv',
    event_params: {
      page: '/csi/beneficios',
      page_title: 'CSI - Beneficios',
      product: 'CSI',
      action_type: 'click',
      action: 'Click botón Conoce nuestros planes',
      view_type: 'web',
      product_type: '',
      asegurados: '',
      enfermedad: '',
      prima: '',
      venta_asistida: '',
      rut_agente: '',
    },
    user: { userId: '' },
    userEmail: '',
  });

const showPlansDetailsInBenefitsBtnEvent = (): void =>
  baseDataLayer({
    event: 'vpv',
    event_params: {
      page: '/csi/beneficios',
      page_title: 'CSI - Beneficios',
      product: 'CSI',
      action_type: 'click',
      action: 'Click link Ver detalles de cada plan',
      view_type: 'web',
      product_type: '',
      asegurados: '',
      enfermedad: '',
      prima: '',
      venta_asistida: '',
      rut_agente: '',
    },
    user: { userId: '' },
    userEmail: '',
  });

const showPremiumDetailInBenefitsBtnEvent = (planName: string): void =>
  baseDataLayer({
    event: 'vpv',
    event_params: {
      page: '/csi/beneficios',
      page_title: 'CSI - Beneficios',
      product: 'CSI',
      action_type: 'click',
      action: 'Click link Ver detalles del Plan Premium',
      view_type: 'web',
      product_type: planName,
      asegurados: '',
      enfermedad: '',
      prima: '',
      venta_asistida: '',
      rut_agente: '',
    },
    user: { userId: '' },
    userEmail: '',
  });

export {
  benefitsLandingViewPageEvent,
  benefitsPageBtnEvent,
  showPlansDetailsInBenefitsBtnEvent,
  showPlansInBenefitsBtnEvent,
  showPremiumDetailInBenefitsBtnEvent,
};
